<template>
    <div class="binging-container">
        <van-form @submit="bindingCard">
            <van-field
                v-if="allowField.indexOf('site_id') !== -1"
                v-model="selectSiteName"
                is-link
                readonly
                name="site_id"
                label="办卡站点"
                placeholder="点击选择站点"
                @click="showSiteSelectPicker = true"
            />
            <van-field
                v-if="allowField.indexOf('userNo') !== -1"
                v-model="formData.userNo"
                name="userNo"
                label="油卡卡号"
                placeholder="请输入油卡卡号"
                :rules="[{ required: true }]"
            />
            <van-field
                v-if="allowField.indexOf('Password') !== -1"
                v-model="formData.Password"
                type="password"
                name="password"
                label="油卡密码"
                placeholder="六位数字密码"
                :rules="[{ message: '请填写六位数字密码', validator: passwordVerify }]"
            />
            <van-field
                v-if="allowField.indexOf('Phone') !== -1"
                v-model="formData.Phone"
                name="phone"
                label="手机号"
                placeholder="请输入手机号"
            />
            <div class="card-option">
                <van-button block type="primary" native-type="submit">绑定油卡</van-button>
            </div>
        </van-form>
        <van-popup v-model:show="showSiteSelectPicker" position="bottom">
            <van-picker :columns="siteNames" @confirm="siteConfirm" @cancel="showSiteSelectPicker = false" :show-toolbar="true" />
        </van-popup>
    </div>
</template>

<script>
    import api from '../../assets/js/api'

    export default {
        name: 'Binding',
        data () {
            return {
                showSiteSelectPicker : false,
                siteData : [],
                selectSiteName : '',
                allowField: ['userNo', 'Password', 'Phone'],
                formData : {
                    site_id: '',
                    userNo: '',
                    Password: '',
                    Phone: ''
                },
            }
        },
        created () {
            let self = this;
            api.request('/user_card/entity_card_bind_field').then(res => {
                self.allowField = res.data;
            });
            api.request('/site/enum').then(res => {
                let siteData = [];
                for(let id in res.data){
                    siteData.push({
                        id : id,
                        name : res.data[id],
                    });
                }
                self.siteData = siteData;
            });
        },
        mounted () {

        },
        computed: {
            siteNames(){
                let names = [];
                for(let i = 0; i < this.siteData.length; i++){
                    names.push(this.siteData[i]['name']);
                }
                return names;
            },
        },
        methods: {
            bindingCard () {
                let self = this;
                api.request('/user_card/bind_entity_card', Object.assign({}, this.formData)).then(res => {
                    self.$dialog.alert({
                    title: res.msg,
                    message: '即将跳转至我的卡片页面',})
                    .then(() => {
                        self.$router.push({ name : 'Card' });
                    });
                }).catch(err => {
                    self.$dialog.alert({
                        message: err.msg,
                    });
                })
            },
            // 表单正则效验
            passwordVerify (val) {
                const passwordReg = /^\d{6}$/
                return passwordReg.test(val)
            },
            phoneVerify (val) {
                const phoneReg = /^(13[0-9]|14[5|7|9]|15[0-3|5-9]|166|17[0-3|5-8]|18[0-9]|19[8-9])\d{8}$/
                return phoneReg.test(val)
            },
            siteConfirm(value, index){
                this.formData.site_id = this.siteData[index]['id'];
                this.selectSiteName = this.siteData[index]['name'];
                this.showSiteSelectPicker = false;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .van-cell {
        padding-left: 20px;
        padding-right: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/card/Binding.vue